import {
  hideQuestionDetailsAction, // updateQuestionDetailsAction
} from 'actions/questionDetails';

import { getQuestionDetailsRoute, getRouteAfterRemovingQuestionDetails } from 'constants/helper';

export const showQuestionDetails =
  ({ questionId, action, source, history }) =>
  (dispatch) => {
    history.push(getQuestionDetailsRoute({ location: history.location, questionId, action, source }));
    // return dispatch(updateQuestionDetailsAction({ questionId, action, source }));
  };

export const hideQuestionDetails =
  ({ updatedQuestion, history }) =>
  (dispatch) => {
    const route = getRouteAfterRemovingQuestionDetails({ location: history.location });
    history.push(route);
    return dispatch(hideQuestionDetailsAction({ updatedQuestion }));
  };
